/**
 * @generated SignedSource<<882afbc89877fa6abd34f117bcc3506e>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ApprovalFilter = "AWAITING_ANY" | "AWAITING_MINE" | "HAS_ANY" | "HAS_MINE";
export type CompetitionApprovalsFragmentPaginationQuery$variables = {
  approvalFilter?: ApprovalFilter | null | undefined;
  count?: number | null | undefined;
  cursor?: string | null | undefined;
  id: string;
  stage?: number | null | undefined;
};
export type CompetitionApprovalsFragmentPaginationQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"SubmissionsCompetitionApprovalsFragment">;
  };
};
export type CompetitionApprovalsFragmentPaginationQuery = {
  response: CompetitionApprovalsFragmentPaginationQuery$data;
  variables: CompetitionApprovalsFragmentPaginationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "approvalFilter"
},
v1 = {
  "defaultValue": 10,
  "kind": "LocalArgument",
  "name": "count"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cursor"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "stage"
},
v5 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v6 = {
  "kind": "Variable",
  "name": "approvalFilter",
  "variableName": "approvalFilter"
},
v7 = {
  "kind": "Variable",
  "name": "stage",
  "variableName": "stage"
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v11 = {
  "alias": "viewerCanApprove",
  "args": [
    {
      "kind": "Literal",
      "name": "action",
      "value": "CREATE_PROJECT_VERSION_APPROVAL"
    }
  ],
  "kind": "ScalarField",
  "name": "viewerCan",
  "storageKey": "viewerCan(action:\"CREATE_PROJECT_VERSION_APPROVAL\")"
},
v12 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  (v6/*:: as any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  (v7/*:: as any*/)
],
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "username",
  "storageKey": null
},
v14 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isEntity"
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageThumbnail",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "version",
  "storageKey": null
},
v18 = [
  (v9/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "title",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "description",
    "storageKey": null
  }
],
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accept",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notes",
  "storageKey": null
},
v22 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  }
],
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/),
      (v4/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CompetitionApprovalsFragmentPaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v5/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": [
              (v6/*:: as any*/),
              {
                "kind": "Variable",
                "name": "count",
                "variableName": "count"
              },
              {
                "kind": "Variable",
                "name": "cursor",
                "variableName": "cursor"
              },
              (v7/*:: as any*/)
            ],
            "kind": "FragmentSpread",
            "name": "SubmissionsCompetitionApprovalsFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v4/*:: as any*/),
      (v3/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "CompetitionApprovalsFragmentPaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v5/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v8/*:: as any*/),
          (v9/*:: as any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v10/*:: as any*/),
              (v11/*:: as any*/),
              {
                "alias": null,
                "args": (v12/*:: as any*/),
                "concreteType": "SubmissionConnection",
                "kind": "LinkedField",
                "name": "submissions",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SubmissionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Submission",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v9/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "entity",
                            "plural": false,
                            "selections": [
                              (v8/*:: as any*/),
                              (v13/*:: as any*/),
                              (v14/*:: as any*/),
                              (v15/*:: as any*/),
                              (v16/*:: as any*/),
                              (v9/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CompetitionStage",
                            "kind": "LinkedField",
                            "name": "stage",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "seq",
                                "storageKey": null
                              },
                              (v9/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "first",
                                "value": 5
                              }
                            ],
                            "concreteType": "SubmissionWorkspaceVersionConnection",
                            "kind": "LinkedField",
                            "name": "workspaceVersions",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "WorkspaceVersion",
                                "kind": "LinkedField",
                                "name": "nodes",
                                "plural": true,
                                "selections": [
                                  (v9/*:: as any*/),
                                  (v17/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Workspace",
                                    "kind": "LinkedField",
                                    "name": "workspace",
                                    "plural": false,
                                    "selections": [
                                      (v10/*:: as any*/),
                                      (v9/*:: as any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "workspaceVersions(first:5)"
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProjectVersion",
                            "kind": "LinkedField",
                            "name": "latest",
                            "plural": false,
                            "selections": [
                              (v9/*:: as any*/),
                              (v17/*:: as any*/),
                              {
                                "alias": "viewerCanReadFiles",
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "action",
                                    "value": "READ_PROJECT_VERSION_FILE"
                                  }
                                ],
                                "kind": "ScalarField",
                                "name": "viewerCan",
                                "storageKey": "viewerCan(action:\"READ_PROJECT_VERSION_FILE\")"
                              },
                              {
                                "alias": "approvalsCheck",
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 2
                                  }
                                ],
                                "concreteType": "ProjectVersionApprovalConnection",
                                "kind": "LinkedField",
                                "name": "approvals",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ProjectVersionApproval",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": "viewerCanRead",
                                        "args": [
                                          {
                                            "kind": "Literal",
                                            "name": "action",
                                            "value": "READ_PROJECT_VERSION_APPROVAL"
                                          }
                                        ],
                                        "kind": "ScalarField",
                                        "name": "viewerCan",
                                        "storageKey": "viewerCan(action:\"READ_PROJECT_VERSION_APPROVAL\")"
                                      },
                                      (v9/*:: as any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": "approvals(first:2)"
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "status",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProjectVersionEvaluation",
                                "kind": "LinkedField",
                                "name": "evaluation",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "score",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "error",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "finalizedAt",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "max",
                                    "storageKey": null
                                  },
                                  (v9/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "project",
                                "plural": false,
                                "selections": [
                                  (v8/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CompetitionStage",
                                    "kind": "LinkedField",
                                    "name": "stage",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "showMetric",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "noCode",
                                        "storageKey": null
                                      },
                                      (v9/*:: as any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "CompetitionScoringCriterion",
                                        "kind": "LinkedField",
                                        "name": "scoringCriteria",
                                        "plural": true,
                                        "selections": (v18/*:: as any*/),
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v9/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "entity",
                                "plural": false,
                                "selections": [
                                  (v8/*:: as any*/),
                                  (v15/*:: as any*/),
                                  (v13/*:: as any*/),
                                  (v9/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProjectVersionApproval",
                                "kind": "LinkedField",
                                "name": "approval",
                                "plural": false,
                                "selections": [
                                  (v8/*:: as any*/),
                                  (v9/*:: as any*/),
                                  (v19/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ProjectVersionApprovalScore",
                                    "kind": "LinkedField",
                                    "name": "scores",
                                    "plural": true,
                                    "selections": [
                                      (v9/*:: as any*/),
                                      (v20/*:: as any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "CompetitionScoringCriterion",
                                        "kind": "LinkedField",
                                        "name": "competitionScoringCriterion",
                                        "plural": false,
                                        "selections": [
                                          (v9/*:: as any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v21/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              (v11/*:: as any*/),
                              {
                                "alias": null,
                                "args": (v22/*:: as any*/),
                                "concreteType": "ProjectVersionApprovalConnection",
                                "kind": "LinkedField",
                                "name": "approvals",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ProjectVersionApprovalEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      (v23/*:: as any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ProjectVersionApproval",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v19/*:: as any*/),
                                          (v21/*:: as any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ProjectVersionApprovalScore",
                                            "kind": "LinkedField",
                                            "name": "scores",
                                            "plural": true,
                                            "selections": [
                                              (v9/*:: as any*/),
                                              (v20/*:: as any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "CompetitionScoringCriterion",
                                                "kind": "LinkedField",
                                                "name": "competitionScoringCriterion",
                                                "plural": false,
                                                "selections": (v18/*:: as any*/),
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "entity",
                                            "plural": false,
                                            "selections": [
                                              (v8/*:: as any*/),
                                              (v13/*:: as any*/),
                                              (v15/*:: as any*/),
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "jobTitle",
                                                    "storageKey": null
                                                  }
                                                ],
                                                "type": "User",
                                                "abstractKey": null
                                              },
                                              (v14/*:: as any*/),
                                              (v16/*:: as any*/),
                                              (v9/*:: as any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          (v9/*:: as any*/),
                                          (v8/*:: as any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v24/*:: as any*/)
                                ],
                                "storageKey": "approvals(first:10)"
                              },
                              {
                                "alias": null,
                                "args": (v22/*:: as any*/),
                                "filters": null,
                                "handle": "connection",
                                "key": "SubmissionApprovalsFragment_approvals",
                                "kind": "LinkedHandle",
                                "name": "approvals"
                              }
                            ],
                            "storageKey": null
                          },
                          (v8/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      (v23/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v24/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v12/*:: as any*/),
                "filters": [
                  "approvalFilter",
                  "stage"
                ],
                "handle": "connection",
                "key": "CompetitionApprovalsFragment_submissions",
                "kind": "LinkedHandle",
                "name": "submissions"
              }
            ],
            "type": "Competition",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9638e3aa6feb3f7eb117c1297937d249",
    "id": null,
    "metadata": {},
    "name": "CompetitionApprovalsFragmentPaginationQuery",
    "operationKind": "query",
    "text": "query CompetitionApprovalsFragmentPaginationQuery(\n  $approvalFilter: ApprovalFilter\n  $count: Int = 10\n  $cursor: String\n  $stage: Int\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...SubmissionsCompetitionApprovalsFragment_1JmVC3\n    id\n  }\n}\n\nfragment BaseProjectVersionApprovalButtonFragment on ProjectVersion {\n  id\n  version\n  entity {\n    __typename\n    displayName\n    username\n    id\n  }\n  approval {\n    __typename\n    id\n    accept\n    scores {\n      id\n      value\n      competitionScoringCriterion {\n        id\n      }\n    }\n    notes\n  }\n  project {\n    __typename\n    id\n    stage {\n      id\n      scoringCriteria {\n        id\n        title\n        description\n      }\n    }\n  }\n  viewerCanApprove: viewerCan(action: CREATE_PROJECT_VERSION_APPROVAL)\n  ...SubmissionStatusBadgeFragment\n}\n\nfragment EntityProfilePicFragment_49kWkb on Entity {\n  __isEntity: __typename\n  displayName\n  imageThumbnail\n}\n\nfragment SubmissionApprovalsFragment on ProjectVersion {\n  entity {\n    __typename\n    username\n    displayName\n    id\n  }\n  approvals(first: 10) @ifAllowed {\n    edges {\n      cursor\n      node {\n        accept\n        notes\n        scores {\n          id\n          value\n          competitionScoringCriterion {\n            id\n            title\n            description\n          }\n        }\n        entity {\n          __typename\n          username\n          displayName\n          ... on User {\n            jobTitle\n          }\n          ...EntityProfilePicFragment_49kWkb\n          id\n        }\n        id\n        __typename\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment SubmissionStatusBadgeFragment on ProjectVersion {\n  id\n  status\n  version\n  evaluation {\n    score\n    error\n    finalizedAt\n    max\n    id\n  }\n  project {\n    __typename\n    stage {\n      showMetric\n      noCode\n      id\n    }\n    id\n  }\n}\n\nfragment SubmissionsCompetitionApprovalsFragment_1JmVC3 on Competition {\n  slug\n  viewerCanApprove: viewerCan(action: CREATE_PROJECT_VERSION_APPROVAL)\n  submissions(approvalFilter: $approvalFilter, after: $cursor, first: $count, stage: $stage) {\n    edges {\n      node {\n        id\n        entity {\n          __typename\n          username\n          ...EntityProfilePicFragment_49kWkb\n          id\n        }\n        stage {\n          seq\n          id\n        }\n        workspaceVersions(first: 5) @ifAllowed {\n          nodes {\n            id\n            version\n            workspace {\n              slug\n              id\n            }\n          }\n        }\n        latest {\n          id\n          version\n          viewerCanReadFiles: viewerCan(action: READ_PROJECT_VERSION_FILE)\n          approvalsCheck: approvals(first: 2) @ifAllowed {\n            nodes {\n              viewerCanRead: viewerCan(action: READ_PROJECT_VERSION_APPROVAL)\n              id\n            }\n          }\n          ...SubmissionStatusBadgeFragment\n          ...BaseProjectVersionApprovalButtonFragment\n          ...SubmissionApprovalsFragment\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n"
  }
};
})();

(node as any).hash = "41f6912a2a23158d8e4e07af4cf97097";

export default node;
